// Interface

import util from '@/utils/classToObject'
import { IAuthState } from './state'
import { ApiUserRole } from '@/enum/ApiUserRole'

export class AuthGetter {
  public isAuthenticated(state: IAuthState) {
    return state.userProfile && state.userProfile.id > 0
  }
  public authStatus(state: IAuthState) {
    return state.authStatus
  }
  public token(state: IAuthState) {
    return state.token
  }
  public userProfile(state: IAuthState) {
    return state.userProfile
  }
  public userSecurity(state: IAuthState) {
    return state.userSecurity
  }
  public renewTokenId(state: IAuthState) {
    return state.renewTokenId
  }
  public redirectPath(state: IAuthState) {
    return state.redirectPath
  }
  public isCentralWeb(state: IAuthState){
    return state.userProfile.usr.usrRole == ApiUserRole.CentralWeb
  }
  public isAdmin(state: IAuthState) {
    return state.userProfile.usr.usrRole == ApiUserRole.Admin
  }  
  public isOperator(state: IAuthState) {
    return state.userProfile.usr.usrRole == ApiUserRole.Operator
  }
  /*public isReader(state: IAuthState) {
    return state.userProfile.usr.usrRole == ApiUserRole.Reader
  }*/
  public isDartyPro(state: IAuthState){
    return state.userProfile.ensId == 3
  }
  public isDarty(state: IAuthState){
    return state.userProfile.ensId == 1
  }
  public isMgd(state: IAuthState){
    return state.userProfile.ensId == 2
  }
}

export default util.classToObject(AuthGetter)
